import { render, staticRenderFns } from "./FormEmpresa.vue?vue&type=template&id=4f616820&"
import script from "./FormEmpresa.vue?vue&type=script&lang=js&"
export * from "./FormEmpresa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports